import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Spacer from "../common/Spacer";

function Aboutus({ isPage = false }) {
  const { t } = useTranslation();

  const highlightBrand = (text) => {
    const parts = text.split(/(Aypin Otomat)/g);

    return parts.map((part, i) =>
      part === "Aypin Otomat" ? (
        <span key={i} className="brand-name">
          Aypin Otomat
        </span>
      ) : (
        part
      )
    );
  };

  return (
    <section
      id="about"
      className="contact"
      aria-labelledby="about-title"
    >
      <Spacer />

      <div
        className="container"
        data-aos="fade-up"
      >
        {/* BAŞLIK */}
        <div className="section-title">
          {isPage ? (
            <h1 id="about-title">
              {t("HAKKIMIZDA")}
            </h1>
          ) : (
            <h2 id="about-title">
              {t("HAKKIMIZDA")}
            </h2>
          )}
        </div>

        <div className="row align-items-center">

          {/* GÖRSEL */}
          <div className="col-lg-5">
            <img
              src="/assets/img/Aypinautomat/10.webp"
              className="img-fluid"
              alt={t(
                "Aypin Otomat CNC kayar otomat ve talaşlı imalat"
              )}
              title={t("Aypin Otomat")}
              loading="lazy"
              decoding="async"
              style={{
                borderRadius: "5px",
                width: "100%",
                height: "auto",
              }}
            />
          </div>

          {/* İLK İÇERİK */}
          <div className="col-lg-7">
            <div
              style={{
                fontSize: "16px",
                textAlign: "justify",
              }}
            >
              <p>
                {highlightBrand(t("About.Para1"))}
              </p>

              <p>
                {highlightBrand(t("About.Para2"))}
              </p>

              <p>
                {highlightBrand(t("About.Para3"))}
              </p>
            </div>
          </div>

          {/* DEVAM İÇERİĞİ */}
          <div className="col-lg-12 mt-4">
            <div
              style={{
                fontSize: "16px",
                textAlign: "justify",
              }}
            >
              <p>
                {highlightBrand(t("About.Para4"))}
              </p>

              <p>
                {highlightBrand(t("About.Para5"))}
              </p>

              <p>
                {highlightBrand(t("About.Para6"))}
              </p>
            </div>

            {/* SADECE ANA SAYFADA GÖSTER */}
            {!isPage && (
              <Link
                to="/hakkimizda"
                className="btn-get-started"
                aria-label={t(
                  "Aypin Otomat hakkında daha fazla bilgi"
                )}
                onClick={() => window.scrollTo(0, 0)}
              >
              </Link>
            )}
          </div>

        </div>
      </div>
    </section>
  );
}

export default Aboutus;